import pluralize from 'pluralize'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

import { stringifyDate, useListData } from '../../modules'

import Receive from "../../components/reusable/receive"
import SingleItemRequest from '../../components/modals/singleItemRequest'
import IssueSingleRequest from '../../components/modals/issueSingleRequest'

const CriticalItems = ({ store }) => {
    const { lastInventoryAlert } = useSelector(state => state.application)
    const [sString, setSString] = useState('')
    
    const [
        { loading, error, fetch },
        { list: items },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('criticalItems', {
        store: store?._id,
        string: sString
    }, { notify: true }, 'items')

    const refresh = resetNav => {
        if (resetNav)
            navigate(1)

        fetch()
    }

    const searchSent = str => {
        setSString(str)
        if (str?.trim()?.length > 2 || !str) {
            setSString(str)
            refresh(true)
        }
    }

    useEffect(() => {
        if (!store?._id || !lastInventoryAlert) return
        if (lastInventoryAlert.type !== 'low-stock-alert') return
        if (lastInventoryAlert.storeId !== store._id && lastInventoryAlert.destination !== store.name) return
        fetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastInventoryAlert, store?._id, store?.name])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="flex items-center justify-between w-full">
                    <input
                        onChange={e => searchSent(e.target.value)}
                        value={ sString }
                        className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Diclofenac Injection" />
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Critical Items</h2>
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                items.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Item</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Current Level</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Reorder Level</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Last Deduction</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                items.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ item.item.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{  item.current } { pluralize(item?.item?.issuedIn, item.current) }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{  item.quantity } { pluralize(item?.item?.issuedIn, item.quantity) }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(item.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            {/* <Link to={ `/app/store/department-requests/requests/${store?._id}/${request._id}${request.issued ? '' : '/issue'}` }>
                                                            <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req.discarded) ? 'bg-gray-600' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>                                                           </Link> */}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No critical items { sString?.trim()?.length > 2 ? `named "${sString}"` : '' } been found</h2>
                                    </div>
                            }
                        </Receive>
                        { Paginate }
                    </div>
                </div>
            </div>
            <Switch>
                <Route exact path="/app/store/department-requests/requests/:id/:rq">
                    <SingleItemRequest path="/app/store/department-requests" onPerform={ refresh } />
                </Route>
                <Route path="/app/store/department-requests/requests/:id/:rq/issue">
                    <IssueSingleRequest path="/app/store/department-requests" onPerform={ refresh } />
                </Route>
            </Switch>
        </div>        
    )

}

export default CriticalItems
